import { listCountries } from 'consts/data';

export default () => {
  return listCountries.map((el) => {
    return {
      ...el,
      iso: el.code,
    };
  });
};
